import React, { Component, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const MenuTree = (props) => {
    const [activeNode, setActiveNode] = useState({});
    useEffect(() => {
        document.body.classList.add('doc-type');

        return () => {
            document.body.classList.remove('doc-type');
        }
    }, []);

    useEffect(() => {
        if(props.current.item)
            setActiveNode(props.current);
    }, [props.current]);

    const onClickNode = node => {
        setActiveNode(node);
        props.onClickNode(node);
    }

    let menudata = [];
    if (props.data !== null && props.data.children !== undefined) {
        if (props.data.children.length > 0)
            menudata = props.data.children;
    }
    return (
        <SubTreeContainer data={menudata} depth={0} treeview={true} onClickNode={onClickNode} activeNode={activeNode} nodepath={props.nodepath} docNo={''} />
    );
}

export default MenuTree;

const Node = (props) => {
    const li = React.createRef();

    const nodeClick = (e, node) => {
        if (node.item.location !== undefined) {
            var newTab = window.open(node.item.location.replace(".", window.location.origin), "_blank");
            newTab.focus();
        }
        else
            props.onClickNode(node);
    }

    useEffect(() => {
        if (props.activate) {
            li.current.scrollIntoView();
        }
    }, []);

    let icoOutlink = [];

    if (props.item.location !== undefined || props.item.opentab !== undefined) {
        icoOutlink.push(
            <span className="icoOutlink">
                <i className="icoKdc20 export"></i>
            </span>
        );
    }
    var activateClass = props.activate ? ' on' : '';
    return (
        // 파일
        <li ref={li}>
            <a href={() => { }}
                className={"depth-" + props.depth + activateClass}
                onClick={e => nodeClick(e, props)}
            >
                <span style={{ "paddingLeft": "20px" }} className="txt file"><i className="icoKdc20 document"></i>{props.name}{icoOutlink}</span>
            </a>
        </li>
    );
}

const SubTree = (props) => {
    const [state, setState] = useState({
        expandClass: props.collapsed ? "btn-expand collapse" : "btn-expand",
        collapsed: props.collapsed
    });


    const onClickNode = node => {
        props.onClickNode(node);
    };

    const changeCollapse = (e) => {
        e.preventDefault();
        if (state.collapsed) {
            setState({ expandClass: "btn-expand", collapsed: false });
        } else {
            setState({ expandClass: "btn-expand collapse", collapsed: true });
        }
    };

    var activateClass = props.activate ? ' on' : '';
    return (
        // 폴더
        <li>
            <a className={"depth-" + props.depth + activateClass} href={() => { }} onClick={() => onClickNode(props)} >
                <div className={state.expandClass} onClick={(e) => changeCollapse(e)}>
                    <i className="icoKdc16 expand"></i>
                </div>
                <span className="txt"> <i className="icoKdc20 document"></i>{props.name}</span>
            </a>
            <SubTreeContainer
                key={props.index + 1}
                data={props.data}
                depth={props.depth}
                path={props.path}
                treeview={state.collapsed ? false : true}
                onClickNode={onClickNode}
                item={props.item}
                activeNode={props.activeNode}
                nodepath={props.nodepath}
                docNo={props.docNo}
            />
        </li>
    );
};

const SubTreeContainer = (props) => {

    const onClickNode = node => {
        props.onClickNode(node);
    };

    const isHasItemFunc = (data, pathArr) => {
        if (!Array.isArray(pathArr) || pathArr.length === 0) {
            return false;
        }

        for (let i = 0; i < data.length; i++) {
            if (pathArr[0] === data[i].module) {
                if (pathArr.length === 1) {
                    return true;
                }
                return isHasItemFunc(data[i].children, pathArr.slice(1));
            }
        }
        return false;
    };

    const items = props.data;
    let style = {
        display: props.treeview ? "block" : "none",
        animation: "scale - display--reversed .3s"
    };
    let treeItems = [];
    let index = 0;
    let depth = props.depth + 1;
    let path = props.path ? props.path : [];
    if (props?.item?.filterPath !== undefined) {
        path = props.item.filterPath;
    }

    let nodepath = props.nodepath ? props.nodepath : [];

    for (let i = 0; i < items.length; i++) {
        let isactive = props.activeNode?.item?.manualId === items[i].manualId;

        if (items[i].hasOwnProperty("children") && items[i].children.length > 0) {
            let isCollapsed = items[i].collapsed !== undefined ? items[i].collapsed : false;
            let isHasItem = false, itemArr = [];

            if (nodepath.length > 0) {
                itemArr.push(items[i]);
                isHasItem = isHasItemFunc(itemArr, nodepath);

                if (isHasItem) {
                    nodepath.shift(); // 첫 번째 요소 제거
                    isCollapsed = false;
                }
            }

            treeItems.push(
                <SubTree
                    key={index++}
                    index={index + 1}
                    name={items[i].module}
                    data={items[i].children}
                    depth={depth}
                    path={[...path, items[i].module]}
                    collapsed={isCollapsed}
                    onClickNode={onClickNode}
                    item={items[i]}
                    activate={isactive}
                    activeNode={props.activeNode}
                    nodepath={nodepath}
                    docNo={props.docNo + '-' + (index + 1)}
                />
            );
        } else {
            treeItems.push(
                <Node
                    key={index++}
                    name={items[i].module}
                    path={[...path, items[i].module]}
                    onClickNode={onClickNode}
                    depth={depth}
                    item={items[i]}
                    activate={isactive}
                    docNo={props.docNo + '-' + (index + 1)}
                />
            );
        }
    }
    return (
        // 전체 트리
        <ul className={props.depth === 0 ? "tree" : ""} style={style}>
            {treeItems}
        </ul>
    );
};